import * as React from 'react';
import { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker as Picker } from '@mui/x-date-pickers/DatePicker';

interface PickerProps {
  label: string;
  handleChange: (value: Dayjs | null) => void;
  value: Dayjs | null;
}

const DatePicker: React.FC<PickerProps> = ({ label, handleChange, value }) => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DemoContainer components={['DatePicker']}>
      <Picker
        label={label}
        value={value}
        onChange={(newValue) => handleChange(newValue)}
      />
    </DemoContainer>
  </LocalizationProvider>
);

export default DatePicker;
